import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Dialog,
  Typography,
  Stack,
  Grid,
  CircularProgress,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useSelector } from "react-redux";
// import EncryptionHelper from "../../shared/EncryptionHelper";
// import { POST } from "../../api/ApiService";
// import { toast } from "react-toastify";
import AddEditContacts from "../AddEditContacts";
import { storeContactData } from "../../slices/contactSlice";
import { useDispatch } from "react-redux";
import {
  FirstPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage,
} from "@mui/icons-material";
import EncryptionHelper from "../../shared/EncryptionHelper";
import { toast } from "react-toastify";
import { GET, PUT } from "../../api/ApiService";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonCommon from "../../shared/ButtonCommon";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SearchBar from "../../shared/SearchBar";
import debounce from "lodash.debounce";

const headerConfig = [
  { id: "actions", label: "Actions", sortable: false },
  { id: "Name", label: "Name", sortable: true },
  { id: "Email", label: "Email", sortable: true },
  { id: "Phone", label: "Phone", sortable: true },
  { id: "Note", label: "Note", sortable: true },
  { id: "Type", label: "Type", sortable: true },
  { id: "CreatedBy", label: "Created By", sortable: true },
  { id: "ModifiedBy", label: "Modified By", sortable: true },
  { id: "CreatedAt", label: "Created At", sortable: true },
  { id: "ModifiedAt", label: "Modified At", sortable: true },
  { id: "Active", label: "Active", sortable: true },
];

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    // if (page > 1) {
    onPageChange(event, page - 1);
    // }
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div style={{ flexShrink: 0, marginLeft: "2.5rem" }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPage />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPage />
      </IconButton>
    </div>
  );
}

const ContactsTable = ({
  contactData,
  totalContactData,
  setContactData,
  setTotalContactData,
  getContactList,
  visibility,
}) => {
  const dispatch = useDispatch();

  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [deleteData, setDeleteData] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getContactList(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const editIconHandler = (item) => {
    dispatch(storeContactData(item));
    setOpenDialog(true);
  };

  const closeDialogHandler = () => {
    setOpenDialog(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleStatusChange = async () => {
    try {
      const putData = {
        ContactID: deleteData?.ContactID,
        IsActive: deleteData?.IsActive === 1 ? 0 : 1,
      };

      const encryptData = EncryptionHelper.encryptData(putData);

      const resp = await PUT("contact/change-IsActive", { encryptData });

      toast.success(resp?.message);
      setOpenDelete(false);
      getContactList();
    } catch (err) {
      console.warn(err);
      toast.error(err?.response?.data?.message);
    }
  };

  const deleteIconHandler = (item) => {
    setDeleteData(item);
    setOpenDelete(true);
  };
  const getContactSearchValue = useCallback(
    debounce(async (value) => {
      setLoading(true); // optional: use if you have a loading spinner
      try {
        const response = await GET(
          `contact/fetchAll?limit=${rowsPerPage}&page=1&visibility=${visibility}&search=${encodeURIComponent(
            value
          )}`
        );
        setContactData(response.data);
        setTotalContactData(response?.total || 0);
        setPage(0); // reset to first page
      } catch (err) {
        toast.error(err?.response?.data?.message || "Search failed");
      } finally {
        setLoading(false); // optional
      }
    }, 800),
    [rowsPerPage]
  );

  return (
    <Box>
      <Stack flexDirection={"row"} justifyContent={"flex-end"} gap={2} m={2}>
        <SearchBar
          searchHeight={"40px"}
          placeholder={"Search for case"}
          fullWidth={false}
          searchValue={getContactSearchValue}
        />
      </Stack>
      {loading ? (
        <Stack justifyContent={"center"} alignItems={"center"} height={400}>
          <CircularProgress />
        </Stack>
      ) : (
        <>
          {contactData?.length > 0 ? (
            <>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {headerConfig?.map((item, index) => (
                        <TableCell key={index}>{item?.label}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {contactData?.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <EditIcon
                            onClick={() => editIconHandler(item)}
                            sx={{ cursor: "pointer" }}
                          />
                        </TableCell>
                        <TableCell>{item.Name}</TableCell>
                        <TableCell>
                          {item.Email ? item.Email : "null"}
                        </TableCell>
                        <TableCell>
                          {item.Phone ? item.Phone : "null"}
                        </TableCell>
                        <TableCell>{item.Note ? item.Note : "null"}</TableCell>
                        <TableCell>{item.Type}</TableCell>
                        <TableCell>{item.CreatedByUserName}</TableCell>
                        <TableCell>
                          {item.ModifiedByUserName
                            ? item?.ModifiedByUserName
                            : "null"}
                        </TableCell>
                        <TableCell>
                          {item.DateCreated
                            ? moment.utc(item.DateCreated).local().format("LLL")
                            : "null"}
                        </TableCell>
                        <TableCell>
                          {item.DateModified
                            ? moment.utc(item.DateModified).local().format("LLL")
                            : "null"}
                        </TableCell>
                        <TableCell>
                          <>
                            <DeleteIcon
                              color="error"
                              sx={{ cursor: "pointer" }}
                              onClick={() => deleteIconHandler(item)}
                            />
                          </>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[100, 250, 300]}
                component="div"
                count={totalContactData}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </>
          ) : (
            <Box>
              <Stack justifyContent="center" alignItems="center" height={200}>
                <Typography>No Contact found</Typography>
              </Stack>
            </Box>
          )}
        </>
      )}

      <AddEditContacts
        openDialog={openDialog}
        closeDialogHandler={closeDialogHandler}
        getContactList={getContactList}
      />

      <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
        <Stack gap={2} p={2}>
          <Stack alignItems={"center"} gap={2}>
            <HighlightOffIcon color="error" sx={{ fontSize: "100px" }} />
            <Typography variant="h6">
              Are you sure, you want to delete this contact?
            </Typography>
            <Grid container pl={6}>
              <Grid item xs={2}>
                Name
              </Grid>
              <Grid item xs={10}>
                <Typography>{deleteData?.Name}</Typography>
              </Grid>
              <Grid item xs={2}>
                Email
              </Grid>
              <Grid item xs={10}>
                <Typography>{deleteData?.Email}</Typography>
              </Grid>
              <Grid item xs={2}>
                Phone
              </Grid>
              <Grid item xs={10}>
                <Typography>{deleteData?.Phone}</Typography>
              </Grid>
            </Grid>
          </Stack>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap={2}
            p={2}
          >
            <ButtonCommon btnClicked={handleStatusChange}>Confirm</ButtonCommon>
            <ButtonCommon btnClicked={() => setOpenDelete(false)}>
              Cancel
            </ButtonCommon>
          </Stack>
        </Stack>
      </Dialog>
    </Box>
  );
};

export default ContactsTable;
